import { OddStyles } from "../../contracts";
import { StaticDecimalLocalizator } from "../../helpers";
import { isNonRunner } from "../isNonRunner";
export const mapSelectionsOdds = (selections, oddStyle, dict) => {
    return selections.map(selection => {
        selection.odds = isNonRunner(selection)
            ? dict.NR
            : selection.displayOdds[OddStyles[oddStyle]];
        const localizator = StaticDecimalLocalizator.getInstance();
        if (localizator) {
            selection.odds = localizator.localizeOdd(selection.odds, oddStyle);
        }
        return selection;
    });
};
//# sourceMappingURL=mapSelectionsOdds.js.map